import React from 'react'

// eslint-disable-next-line no-unused-vars
import { ISearchContext } from '../interfaces/search'

export const SearchContext = React.createContext<ISearchContext>({
  search: '',
  setSearch: () => {},
  isSearching: () => true
})
